// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3p0iG","inputWrap":"Table_inputWrap__15UaJ","col":"Table_col__1E4nq","bmiTooltip":"Table_bmiTooltip__26ssn"};